import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  isConnected: false
};

const pwcAuthDataSlice = createSlice({
  name: 'pwcAuthData',
  initialState,
  reducers: {
    initPWCConnectedData: () => initialState,
    setPWCConnectedData: (state, action) => {
      // state.isConnected = false;
      state.isConnected = action.payload.isConnected;
    }
  }
});

export const { initPWCConnectedData, setPWCConnectedData } = pwcAuthDataSlice.actions;
export const usePwcAuthDataSliceSelector = createSelectorFn(pwcAuthDataSlice);
export default pwcAuthDataSlice;
